import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import ChurchIcon from "@mui/icons-material/Church";
import ExploreIcon from "@mui/icons-material/Explore";
import GroupIcon from "@mui/icons-material/Group";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

const MobileMoreMenu = ({ open, onClose, prefersDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
    onClose();
  };

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  const menuItems = [
    { text: "主页", icon: <HomeIcon fontSize="small" />, path: "/" },
    { text: "简介", icon: <InfoIcon fontSize="small" />, path: "/intro" },
    { text: "崇拜", icon: <ChurchIcon fontSize="small" />, path: "/worship" },
    {
      text: "异象空间",
      icon: <ExploreIcon fontSize="small" />,
      path: "/vision",
    },
    { text: "事奉同工", icon: <GroupIcon fontSize="small" />, path: "/serve" },
    {
      text: "奉献",
      icon: <VolunteerActivismIcon fontSize="small" />,
      path: "/contact",
    },
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "85%",
          maxWidth: "320px",
          bgcolor: prefersDarkMode ? "#1c1c1e" : "#ffffff",
          color: prefersDarkMode ? "white" : "text.primary",
          boxShadow: prefersDarkMode
            ? "-4px 0 20px rgba(0,0,0,0.5)"
            : "-4px 0 20px rgba(0,0,0,0.1)",
        },
      }}
    >
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            mt: 1,
            px: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "1.1rem" }}>
            导航
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: prefersDarkMode
                ? "rgba(235, 235, 245, 0.6)"
                : "rgba(60, 60, 67, 0.6)",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <List sx={{ flex: 1, px: 1 }}>
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.text}
              onClick={() => handleNavigate(item.path)}
              sx={{
                mb: 0.5,
                borderRadius: "10px",
                py: 1.2,
                bgcolor: isActive(item.path)
                  ? "rgba(10, 132, 255, 0.15)"
                  : "transparent",
                "&:active": {
                  bgcolor: prefersDarkMode
                    ? "rgba(255, 255, 255, 0.1)"
                    : "rgba(0, 0, 0, 0.05)",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: isActive(item.path)
                    ? "#0a84ff"
                    : prefersDarkMode
                    ? "rgba(235, 235, 245, 0.6)"
                    : "rgba(60, 60, 67, 0.6)",
                  minWidth: "36px",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: isActive(item.path) ? 600 : 400,
                    fontSize: "0.95rem",
                    color: isActive(item.path) ? "#0a84ff" : "inherit",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>

        <Box sx={{ mt: "auto", pt: 3, px: 2 }}>
          <Divider
            sx={{
              borderColor: prefersDarkMode
                ? "rgba(84, 84, 88, 0.65)"
                : "rgba(0, 0, 0, 0.1)",
              mb: 2,
            }}
          />
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: prefersDarkMode
                ? "rgba(235, 235, 245, 0.3)"
                : "rgba(60, 60, 67, 0.3)",
              textAlign: "center",
              fontSize: "0.7rem",
              pb: 1,
            }}
          >
            © 2024 3CCA 基督徒联盟
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default MobileMoreMenu;
